import { render, staticRenderFns } from "./OrganisationPanel.vue?vue&type=template&id=c4663b4a&scoped=true&"
import script from "./OrganisationPanel.vue?vue&type=script&lang=js&"
export * from "./OrganisationPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationPanel.vue?vue&type=style&index=0&id=c4663b4a&prod&lang=scss&scoped=true&"
import style1 from "./OrganisationPanel.vue?vue&type=style&index=1&id=c4663b4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4663b4a",
  null
  
)

export default component.exports